import { cloneDeep, concat, get, isEmpty } from 'lodash';
import { Page_Size } from '../../../../Components/helper';
import type from './DamFolder.type';

const initialState = {
  damFolderGroupList: [],
  damDetails: null,
  filesSuggestionList: [],
  damFolderArchivedlist: [],
  damDeletedFolders: [],
  damDeletedCount: 0,
  totalAcrhivedCount: 0,
  totalCount: 0,
  filterValues: {
    pageIndex: 1,
    pageSize: Page_Size,
  },
};

const DamFolderReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DATA_SUCCESS:
      const updatedDamArry = cloneDeep(setArrayByCase(state.damFolderGroupList, action.payload));
      return {
        ...state,
        damFolderGroupList: updatedDamArry,
        totalCount: action?.payload?.totalCount,
      };
    case type.GET_FOLDER_DETAIL:
      return {
        ...state,
        damDetails: action.payload,
      };
    case type.UNMOUNT_FOLDER_DATA:
      return {
        ...state,
        damDetails: null,
      };
    case type.CLEAR_FOLDER_LIST:
      return {
        ...state,
        damFolderGroupList: [],
      };
    case type.FETCH_FILES_SUGGESTION:
      return {
        ...state,
        filesSuggestionList: action.payload,
      };
    case type.SET_FOLDER_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case type.SET_ARCHIVED_FOLDERS:
      const updatedArchivedArry = cloneDeep(setArrayByCase(state.damFolderArchivedlist, action.payload));
      return {
        ...state,
        damFolderArchivedlist: updatedArchivedArry,
        totalAcrhivedCount: action?.payload?.totalCount,
      };
    case type.SET_DELETED_FOLDERS:
      const updatedDeletedArry = cloneDeep(setArrayByCase(state.damDeletedFolders, action.payload));
      return {
        ...state,
        damDeletedFolders: updatedDeletedArry,
        damDeletedCount: action?.payload?.totalCount,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

export default DamFolderReducer;
